//
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import type { Doc } from '@hcengineering/core'
import { type Plugin, type Resource, plugin } from '@hcengineering/platform'
import type { AnyComponent } from '@hcengineering/ui'
import type { CreateAggregationManagerFunc, GrouppingManagerResource, SortFunc } from '@hcengineering/view'

/**
 * Cross-project management of tracker components and milestones.
 *
 * The tracker ships name based aggregation for `Component` only. This plugin adds the
 * same treatment for `Milestone` without touching any tracker file, by attaching the
 * mixins from a model that is registered after the tracker model.
 *
 * @public
 */
export const xprojectId = 'xproject' as Plugin

const xproject = plugin(xprojectId, {
  component: {
    MilestoneRefPresenter: '' as AnyComponent
  },
  aggregation: {
    GrouppingMilestoneManager: '' as GrouppingManagerResource
  },
  function: {
    CreateMilestoneAggregationManager: '' as CreateAggregationManagerFunc,
    SetMilestoneStore: '' as Resource<(manager: any) => void>,
    MilestoneFilterFunction: '' as Resource<(doc: Doc, target: Doc) => boolean>,
    MilestoneSort: '' as SortFunc
  }
})

export default xproject
